
import { AuthProvider } from "react-oidc-context";
import { User, WebStorageStateStore } from "oidc-client-ts";

type Props = {
    children?: React.ReactChild | React.ReactChild[];
  };
  
  const Auth = function ({ children }: Props) {
    const oidcConfig  = {
      onSigninCallback : (user: User|void)=> {
        window.history.replaceState({}, document.title, window.location.pathname);
      },
      authority:'https://sso.1881.no/oauth2',
      client_id:'banfYIhGQ_lqranlIkkNS0xsvpNow1euaAJJAVAWynk-',
      response_type: 'code',
      scope: 'openid profile email',
      loadUserInfo: true,
      redirect_uri: 'https://'+window.location.host,
      post_logout_redirect_uri : 'https://'+window.location.host,
      userStore: new WebStorageStateStore({ store: localStorage})
    };
    
   
   

    return (
      <AuthProvider {...oidcConfig}>
        {children}
      </AuthProvider>
    );
  };

  export default Auth;